<app-loader *ngIf="isDisabled"></app-loader>
<div class="modal-header">
    <p>Date :{{ AttendanceDate }}</p>
    <button type="button" class="btn-close" aria-label="Close" (click)="close(false)"></button>
</div>
<div class="modal-body">
    <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
        <thead class="table-light">
            <tr>
                <th scope="col" style="width: 5px;">#</th>
                <th style="width: 100px;">Branch</th>
                <th style="width: 100px;" [ngClass]="{'colHide': common.ToLowerCase(user.EmpType) == 'back'}">Site</th>
                <th style="width: 100px;">DesignationName</th>
                <th style="width: 100px;">Shift</th>
                <th style="width: 100px;">InTime</th>
                <th style="width: 100px;">OutTime</th>
                <th style="width: 20px;">Remark</th>
                <th style="width: 50px;">Select</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let TableData of EmployeeLeave; let i = index">
                <th scope="row" style="width: 5px;">{{i+1}}</th>
                <td style="width: 100px;">{{TableData['BranchName']}}</td>
                <td style="width: 100px;" [ngClass]="{'colHide': common.ToLowerCase(user.EmpType) == 'back'}">{{TableData['SiteName']}}</td>
                <td style="width: 100px;">{{TableData['DesignationName']}}</td>
                <td style="width: 100px;">{{TableData['ShiftTitle']}}</td>
                <td style="width: 100px;">
                    <div style="width: 100px;">{{TableData['InTime'] | date : 'dd MMM yyyy HH:mm' }}</div>
                </td>
                <td style="width: 100px;">
                    <div style="width: 100px;">{{TableData['OutTime'] | date : 'dd MMM yyyy HH:mm' }}</div>
                </td>
                <td style="width: 20px;">{{TableData['AttendanceRemark']}}</td>
                <td style="width: 5px;">
                    <div style="width: 80px;"><button type="button" class="btn btn-outline-primary btn-sm" (click)="Select(i)"><i
                                class="bi bi-info-square me-1"></i>Select</button></div>
                </td>
            </tr>
        </tbody>
    </table>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled" (click)="close(false)"><i
            class="bi bi-x" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Close':'Loading...'}}</button>
</div>